import React from 'react';

import WhiteTextTypography from 'components/Common/WhiteTextTypography';

import Styles from './index.module.css';

function NoDataDashboard() {
  return (
    <div
      className={Styles.container}
    >
      <WhiteTextTypography fontSize="20px" align="center">您尚未發送任何廣告單元</WhiteTextTypography>
      <WhiteTextTypography fontSize="20px" align="center">PowerAI即時報表數據不足</WhiteTextTypography>
    </div>
  );
}

export default NoDataDashboard;
